import { Collection } from './collection';
import { EntityFields } from './entity';
import { FieldOptions } from './field-options';
import { UserKey } from './key';
import { KeyAndDisplay } from './key-and-display';

export const PublicAccessKey = 'VXNlcgkq';

export enum SecurityAccessFields {
  Read = 'Read',
  Write = 'Write',
}

export interface TypedSecurityAccess<T> {
  [SecurityAccessFields.Read]: T[];
  [SecurityAccessFields.Write]: T[];
}

export interface SecurityAccess extends TypedSecurityAccess<SecurityAccessItem> {
  [EntityFields.DisplayValue]?: string;
}

export interface EntitySecurityAccess {
  [SecurityAccessFields.Read]: Collection<KeyAndDisplay>;
  [SecurityAccessFields.Write]: Collection<KeyAndDisplay>;
}

export type SecurityAccessItem = {
  Key: UserKey;
  DisplayValue?: string;
};

export type SecurityAccessFieldOptions = FieldOptions<{
  SecAccess?: SecurityAccess;
}>;

export interface SecurityAccessFieldOptionsResponse {
  FieldOptions: {
    SecAccess: Partial<SecurityAccess>;
  };
}
